import { getToken, optionalToken } from './user-service';
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { firestore } from "_utils/firebase-app";

//fetching passenger booking that will make the survey.
// Anonymous callers get only { _id, id, firstName, flightConfirmationDetails: { carrierCode,
// flightNumber, departureDate, origin, destination } }; the gateway lets this route through
// with no token. Logged-in callers with access to the booking still get it in full.
export const getBookingService = async (bookingId) => {

    return new Promise(async (resolve, reject) => {
        try {
            const token = await optionalToken();

            const url = `/api/v1/bookings/bookings/reviewBooking/${encodeURIComponent(bookingId)}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    ...(token ? { "Firebase-UID": token } : {}),
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad request details");
            }

            resolve(json);
        } catch (e) {
            reject(new Error("Error getting the booking"));
        }
    });
}
//fetching passenger task that will make the survey
export const getTaskService = async (taskId) => {

    return new Promise(async (resolve, reject) => {
        try {
            // single-document get (task doc id == _id): the rules check the task's own
            // airport, which a query on _id can't prove
            const taskSnapshot = await getDoc(doc(firestore, "tasks", taskId));
            if (taskSnapshot.exists()) {
                const taskData = taskSnapshot.data();

                resolve(taskData);
            } else {
                console.log("No matching task found.");
                resolve({});
            }
        } catch (error) {
            console.error("Error getting task", error);
            reject(error);
        }
    });
}

export const getQuestions = async (data) => {
    // the public survey page (passenger) has no login and sends no credential
    const token = data.passenger ? null : await getToken()


    let url = '/api/v1/review/survey/' + data.iata



    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, { method: 'GET', headers: token ? { "Firebase-UID": token } : {} });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getQuestions"));
        }
    });
};


export const getSurveyIdService = async (params) => {
    const survey_url = `/api/v1/review/survey/surveyIdByIATA/${params.iata}`

    return new Promise(async (resolve, reject) => {
        try {
            const token = await optionalToken();
            const response = await fetch(survey_url, {
                method: "GET",
                headers: {
                    ...(token ? { "Firebase-UID": token } : {}),
                    accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            let json = await response.json();


            if (response.status >= 400 && response.status < 600) {
                console.log("error from review", json);
                throw new Error("Bad request details");
            }

            resolve(json);
        } catch (e) {
            console.log("issue posting review", e);
            reject(e);
        }
    });
};

export const postSureveyQuestionnaireService = async (data) => {
    const token = await getToken()
    let url = '/api/v1/review/survey/' + data.iata

    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'POST', body: JSON.stringify(data),
                headers: { "Firebase-UID": token, "Content-Type": "application/json" }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error saving survey questionnaire"));
        }
    });
}
// Soft delete — the survey is hidden from the builder but kept for past answers.
export const deleteSurveyService = async (data) => {
    const token = await getToken()
    const url = `/api/v1/review/survey/${data.iata}/${encodeURIComponent(data.surveyId)}`

    const response = await fetch(url, {
        method: 'DELETE',
        headers: { "Firebase-UID": token }
    });
    if (response.status >= 400) {
        throw new Error("error deleting survey");
    }
    return response.json();
}

export const updateSurveyAvailabilityService = async (data) => {
    const token = await getToken()
    let url = '/api/v1/review/survey/' + data.iata

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, {
                method: 'PATCH', body: JSON.stringify(data),
                headers: { "Firebase-UID": token, "Content-Type": "application/json" }
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error saving survey questionnaire"));
        }
    });
}

export const getPaxSurveyQuestionsService = async (data) => {

    let url = `/api/v1/review/survey/paxSurvey/${data.surveyId}?language=${data.language}`;
    return new Promise(async (resolve, reject) => {

        try {

            // public survey page: no credential needed
            const response = await fetch(url, {
                method: 'GET',
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveyAnswersService"));
        }
    });
};


export const postSurveyAnswersService = async (data) => {

    let url = '/api/v1/review/survey/survey-answers/'

    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'POST', body: JSON.stringify(data),
                headers: { "Content-Type": "application/json" } // public survey page: no credential
            });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error postSurveyAnswersService"));
        }
    });
};
export const getSurveyAnswersService = async (data) => {

    const url = `/api/v1/review/survey/survey-answers/${data.iata}?surveyId=${data.surveyId}&start=${data.start}&end=${data.end}&limit=${data.limit}&skip=${data.skip}&report=${data.report}`;
    const token = await getToken()
    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'GET',
                headers: { "Firebase-UID": token }
            });
            const json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }


            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveyAnswersService"));
        }
    });
};

// sent vs answered counts for the email surveys of an airport over a date range
export const getSurveySendStatsService = async (data) => {

    let url = `/api/v1/review/survey/survey-sends/stats/${data.iata}?start=${data.start}&end=${data.end}`;
    if (data.surveyId && data.surveyId !== "ALL") url += `&surveyId=${data.surveyId}`;
    const token = await getToken()
    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, {
                method: 'GET',
                headers: { "Firebase-UID": token }
            });
            const json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("error getSurveySendStatsService"));
        }
    });
};